require('./core/axios');
require('./core/vue_core');


import { EventBus } from './core/event-bus';
import store from './app/store';

window.EventBus = EventBus;



//store.dispatch('LOAD_MAIN_CONST');

$(document).ready(function () {
    if($("#user_auth").length > 0 ) {
        require('./app/components/user/index');
    }
    if($("#user_profile_buttons").length > 0 ) {
        require('./app/components/user/buttons/index');
    }


    require('./app/sys/index');
});
